import { Navigate, useParams } from "react-router-dom";
import EssayPrizePageLayout from "./EssayPrizePageLayout";
import CategoryPrizeDetailPanel from "./CategoryPrizeDetailPanel";
import {
  ESSAY_PRIZES_OVERVIEW_PATH,
  ESSAY_PRIZE_CLOSING_DATE,
  ESSAY_PRIZE_HEAR_BACK_DATE,
  essayPrizeMailto,
  getEssayPrizeCategory,
} from "./essayPrizes";

const EssayPrizeCategoryPage = () => {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  const category = getEssayPrizeCategory(categorySlug);
  const submitMailto = category ? essayPrizeMailto(category.mailtoSubject) : "";

  if (!category) {
    return <Navigate to={ESSAY_PRIZES_OVERVIEW_PATH} replace />;
  }

  return (
    <EssayPrizePageLayout
      heroLabel="National competition · 2026"
      heroTitle={
        <>
          {category.title}{" "}
          <span className="tml-hero__title-accent">Essay Prize</span>
        </>
      }
      heroLead={
        <>
          <strong>£500 national prize</strong> · closes <strong>{ESSAY_PRIZE_CLOSING_DATE}</strong> · hear back by{" "}
          <strong>{ESSAY_PRIZE_HEAR_BACK_DATE}</strong>. Open to {category.audienceLabel.toLowerCase()}.
        </>
      }
    >
      <CategoryPrizeDetailPanel category={category} submitMailto={submitMailto} />
    </EssayPrizePageLayout>
  );
};

export default EssayPrizeCategoryPage;
